import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { Permissions } from "permissions";
import { RouteDescription } from "types";
import { downloadLOPRoutes } from "./DownloadLOP";

const AppendToLOPPage = lazy(() => import("./AppendToLOPPage"));

export const lopRoutes: RouteDescription[] = [
  {
    menuItem: {
      id: "lop",
      label: "LOP",
    },
    children: [
      {
        path: links.appendToLOP,
        element: withPageLoader(<AppendToLOPPage />),
        breadcrumb: "Append to LOP list",
        menuItem: {
          id: "append-to-lop",
          label: "Append to LOP list",
        },
        requiredOneOfPermissions: [
          Permissions.Admin,
          Permissions.SuperAdmin,
          Permissions.Compliance,
        ],
      },
      ...downloadLOPRoutes,
    ] as RouteDescription[],
  },
];